import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ArrowLeft, Trash2, Plus } from "lucide-react";
import { usePaymentMethods } from "@/hooks/payments/usePaymentMethods";

interface PaymentMethodManagerProps {
  gymId: string;
  onBack: () => void;
}

export const PaymentMethodManager = ({ gymId, onBack }: PaymentMethodManagerProps) => {
  const { methods, createMethod, deleteMethod, isLoading } = usePaymentMethods(gymId);
  const [newName, setNewName] = useState("");

  const handleCreate = async () => {
    if (!newName.trim()) return;
    await createMethod.mutateAsync({ gym_id: gymId, name: newName.trim() });
    setNewName("");
  };

  return (
    <div className="space-y-4 mt-4">
      <div className="flex items-center gap-2">
        <Button type="button" variant="ghost" size="icon" onClick={onBack}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h3 className="font-semibold">Gestionar métodos de pago</h3>
      </div>

      <div className="flex gap-2">
        <Input
          placeholder="Nuevo método (ej. Mercado Pago)"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleCreate();
            }
          }}
        />
        <Button
          type="button"
          onClick={handleCreate}
          disabled={!newName.trim() || createMethod.isPending}
        >
          <Plus className="h-4 w-4" />
        </Button>
      </div>

      <div className="space-y-2">
        {isLoading ? (
          <p className="text-sm text-muted-foreground">Cargando...</p>
        ) : methods.length === 0 ? (
          <p className="text-sm text-muted-foreground">No hay métodos creados.</p>
        ) : (
          methods.map((m) => (
            <div
              key={m.id}
              className="flex items-center justify-between p-2 rounded-md border border-border"
            >
              <span className="text-sm">{m.name}</span>
              <Button
                type="button"
                variant="ghost"
                size="icon"
                className="h-8 w-8"
                onClick={() => deleteMethod.mutate(m.id)}
                disabled={deleteMethod.isPending}
              >
                <Trash2 className="h-4 w-4 text-destructive" />
              </Button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
